var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadData
    ? _c(
        "v-form",
        { ref: "form", class: { "py-4": _vm.isMobile, "py-5": !_vm.isMobile } },
        [
          _c(
            "div",
            [
              _c("h3", [_vm._v("Service Information")]),
              _vm._v(" "),
              _c("service-information", {
                attrs: {
                  v: _vm.$v.student.form.serviceInformation,
                  absentTypesArray: _vm.absentTypesArray,
                  absentReasonsArray: _vm.absentReasonsArray,
                  absentAlternativesArray: _vm.absentAlternativesArray,
                  groupTypeArray: _vm.groupTypeArray,
                  deliveryModeArray: _vm.deliveryModeArray,
                  serviceDeliveredArray: _vm.serviceDeliveredArray,
                  student: _vm.student,
                  showTooltip: _vm.showTooltip,
                  action: _vm.action,
                  supervisorFlagsArray: _vm.supervisorFlagsArray
                },
                on: { "calculate:minutes": _vm.calculateMinutes }
              }),
              _vm._v(" "),
              _vm.showMedicaid
                ? [
                    !_vm.isConsultation
                      ? _c(
                          "v-layout",
                          {
                            class: {
                              "py-1": _vm.isMobile,
                              "pt-3": !_vm.isMobile
                            },
                            staticStyle: { "padding-bottom": "5px" },
                            attrs: { row: "", wrap: "" }
                          },
                          [
                            _c("v-flex", { attrs: { xs12: "", sm8: "" } }, [
                              _c("h3", [
                                _vm._v(
                                  "Documentation Of Service and Student Performance"
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("extended-service-information", {
                      ref: "extendedServiceInformation",
                      attrs: {
                        student: _vm.student,
                        v: _vm.$v.student.form.serviceInformation,
                        supervisorFlagsArray: _vm.supervisorFlagsArray,
                        action: _vm.action,
                        groupTypeArray: _vm.groupTypeArray,
                        deliveryModeArray: _vm.deliveryModeArray,
                        "relevant-student-behavior": ""
                      }
                    }),
                    _vm._v(" "),
                    !_vm.isConsultation
                      ? _c("v-textarea", {
                          attrs: {
                            label: "Relevant Student Behavior Details",
                            placeholder:
                              "Enter Relevant Student Behavior Details"
                          },
                          on: {
                            blur: function($event) {
                              return _vm.handleTextTrimming(
                                "studentBehavior",
                                _vm.student.form.serviceInformation
                                  .studentBehavior
                              )
                            }
                          },
                          model: {
                            value:
                              _vm.student.form.serviceInformation
                                .studentBehavior,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.student.form.serviceInformation,
                                "studentBehavior",
                                $$v
                              )
                            },
                            expression:
                              "student.form.serviceInformation.studentBehavior"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isConsultation
                      ? _c(
                          "v-layout",
                          {
                            class: {
                              "py-1": _vm.isMobile,
                              "pt-3": !_vm.isMobile
                            },
                            attrs: { row: "", wrap: "" }
                          },
                          [
                            _c("v-flex", { attrs: { xs12: "", sm8: "" } }),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs12: "", sm4: "" } },
                              [
                                _c("v-text-field", {
                                  class: {
                                    "mt-4": _vm.isMobile,
                                    "mt-0 pt-0": !_vm.isMobile
                                  },
                                  attrs: {
                                    label: "Total Reimbursable Minutes",
                                    readonly: "",
                                    "error-messages":
                                      _vm.totalReimbursableMinutesErrors
                                  },
                                  model: {
                                    value:
                                      _vm.student.form.totalReimbursableMinutes,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.student.form,
                                        "totalReimbursableMinutes",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "student.form.totalReimbursableMinutes"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isConsultation
                      ? _c("medicaid-information", {
                          ref: "medicaidInformation",
                          attrs: {
                            student: _vm.student,
                            v: _vm.$v.student.form.medicaid,
                            medicaidArray: _vm.medicaidArray,
                            showTooltip: _vm.showTooltip
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  class: { "py-1": _vm.isMobile, "pt-3": !_vm.isMobile },
                  attrs: { row: "", wrap: "" }
                },
                [
                  _c("extended-service-information", {
                    ref: "extendedServiceInformation",
                    attrs: {
                      student: _vm.student,
                      v: _vm.$v.student.form.serviceInformation,
                      supervisorFlagsArray: _vm.supervisorFlagsArray,
                      action: _vm.action,
                      absentTypesArray: _vm.absentTypesArray,
                      absentReasonsArray: _vm.absentReasonsArray,
                      absentAlternativesArray: _vm.absentAlternativesArray,
                      groupTypeArray: _vm.groupTypeArray,
                      deliveryModeArray: _vm.deliveryModeArray,
                      "objective-note": "",
                      "assessment-of-performance": "",
                      "proposed-plan-and-target": "",
                      signature: ""
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  attrs: { column: "" },
                  model: {
                    value: _vm.saveOptions,
                    callback: function($$v) {
                      _vm.saveOptions = $$v
                    },
                    expression: "saveOptions"
                  }
                },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _vm.index < _vm.arrayLength - 1
                        ? _c("v-radio", {
                            attrs: {
                              slot: "activator",
                              label: "Save & Next Student",
                              value: "next",
                              color: "primary"
                            },
                            slot: "activator"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v("Save and go to next student")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _vm.arrayLength === 1 || _vm.index === _vm.arrayLength - 1
                        ? _c("v-radio", {
                            attrs: {
                              slot: "activator",
                              label: "Save",
                              value: "save",
                              color: "primary"
                            },
                            slot: "activator"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v("Save log")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _vm.arrayLength === 1 && _vm.action !== "edit"
                        ? _c("v-radio", {
                            attrs: {
                              slot: "activator",
                              label: "Save & Clone",
                              value: "copy",
                              color: "primary"
                            },
                            slot: "activator"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v("Save log and create duplicate")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-alert", { attrs: { value: _vm.errorMsg, type: "error" } }, [
                _vm._v("\n      " + _vm._s(_vm.errorMsg) + "\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "my-3",
                          attrs: {
                            slot: "activator",
                            color: "primary",
                            round: "",
                            block: _vm.isMobile,
                            disabled: !_vm.saveOptions
                          },
                          on: {
                            click: function($event) {
                              return _vm.submit(_vm.student)
                            }
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n          Submit\n        ")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Submit saved log")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "cancel-button",
                      attrs: { round: "", block: _vm.isMobile },
                      on: { click: _vm.onCancelButtonClicked }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-snackbar",
                {
                  attrs: { timeout: _vm.timeout, color: "cyan darken-2" },
                  model: {
                    value: _vm.toaster,
                    callback: function($$v) {
                      _vm.toaster = $$v
                    },
                    expression: "toaster"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.toasterMsg) + "\n    ")]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("bottom-nav"),
          _vm._v(" "),
          _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-799dbbad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799dbbad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/service-log-form.vue
// module id = null
// module chunks = 